<template>
    <div class="unitSwitcher">
        <button class="btn"
                :class="[value === 'INCH' ? 'btn-primary' : 'btn-secondary']"
                :disabled="disabled"
                @click.prevent="onUnitChanged('INCH')">{{ $t('inches')}}</button>
        <button class="btn"
                :class="[value === 'CM' ? 'btn-primary' : 'btn-secondary']"
                :disabled="disabled"
                @click.prevent="onUnitChanged('CM')">{{ $t('cm')}}</button>
        <button class="btn"
                :class="[value === 'MM' ? 'btn-primary' : 'btn-secondary']"
                :disabled="disabled"
                @click.prevent="onUnitChanged('MM')">{{ $t('mm')}}</button>

        <input type="hidden" :name="inputName ? inputName : 'unit'" :value="value" v-if="withInput">
    </div>
</template>
<script>
    export default {
        props: {
            initialValue: {
                type: String,
                required: false,
                default: false,
            },
            setUnit: {
                type: Function,
                required: false,
            },
            withInput: {
                type: Boolean,
                required: false,
                default: false,
            },
            inputName: {
                type: String,
                required: false,
            },
            disabled: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        data() {
            return {
                value: false,
            }
        },
        created() {
            this.value = this.initialValue
        },
        watch: {
            initialValue: {
                handler(val) {
                    this.value = val
                },
                deep: true
            }
        },
        methods: {
            onUnitChanged(unit) {
                if (!this.disabled) {
                    this.value = unit

                    if (this.setUnit) {
                        this.setUnit(this.value)
                    }
                }
            }
        }
    }
</script>
